"use strict";

import Vue from "vue";
import Vuex from "vuex";
import modals from "./modules/modals";
import cv from "./modules/cv";
import Cookies from "js-cookie";

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    modals,
    cv
  },
  state: {
    isAuthenticated: true,
    testValue: 100,
    authUser: false,
    typeCv: false,
    languages: {},
    translate: {},
    user: {},
    tariffs: {},
    tariffsArray: {},
    tariff: {},
    locale: Cookies.get("locale") || "ru",
    test: 10,
    cvDownloadId: null,
    loadEditCv: false
  },
  mutations: {
    isAuthenticated(state, payload) {
      state.isAuthenticated = payload.isAuthenticated;
    },
    user(state, new_user) {
      if (
        new_user &&
        new_user.avatar !== undefined &&
        new_user.avatar !== null
      )
        if (new_user && new_user.photo === null) {
          new_user.photo = "/vue/images/user_img.jpg";
        }
      if (new_user) {
        state.authUser = true;
      } else {
        state.authUser = false;
      }
      if (new_user)
        state.user = new_user;
      else
        state.user = {};
    },
    cvDownloadId(state, new_id) {
      state.cvDownloadId = new_id;
    },
    languages(state, new_languages) {
      state.languages = new_languages;
    },
    typeCv(state, new_typeCv) {
      state.typeCv = new_typeCv;
    },
    testValue(state, new_testValue) {
      state.testValue = new_testValue;
    },
    loadEditCv(state, new_loadEditCv) {
      state.loadEditCv = new_loadEditCv;
    },
    tariffs(state, new_tariffs) {
      state.tariffs = new_tariffs;
    },
    tariffsArray(state, new_tariffsArray) {
      state.tariffsArray = new_tariffsArray;
    },
    tariff(state, new_tariff) {
      state.tariff = new_tariff;
    },
    translate(state, tmpTranslations) {
      state.translate = tmpTranslations;
    },
    locale(state, new_locale) {
      if (Cookies.get('cv_locale') === undefined) {
        state.cv.cv_locale = new_locale;
      }
      state.locale = new_locale;
    }
  },
  getters: {
    is: state => key => {
      return state.user['is'+key]
    },
    isAuthenticated() {
      return vueAuth.isAuthenticated();
    },
    user: state => {
      return state.user;
    },
    cvDownloadId: state => {
      return state.cvDownloadId;
    },
    authUser: state => {
      return state.authUser;
    },
    typeCv: state => {
      return state.typeCv;
    },
    testValue: state => {
      return state.testValue;
    },
    loadEditCv: state => {
      return state.loadEditCv;
    },
    languages: state => {
      return state.languages;
    },
    tariffs: state => {
      return state.tariffs;
    },
    tariffsArray: state => {
      return state.tariffsArray;
    },
    tariff: state => {
      return state.tariff;
    },
    translate: state => {
      return state.translate;
    },
    t: state => key => {
      return state.translate[key] || key;
    },
    locale: state => {
      return state.locale;
    },
    priceSimbol: state => locale => {
      for (let language in state.languages) {
        if (state.languages[language]["prefix"] == locale) {
          return state.languages[language]["price_text"];
        }
      }
    }
  },
  actions: {
    async getData({commit, getters}) {
      return await axios.get(`/api/main-page`).then(res => {
        commit("languages", res.data.site_languages);
        commit("user", res.data.user);
        commit("tariffs", res.data.tariffs);
        commit("tariffsArray", res.data.tariffsArray);
      });
    },
  }
});



// WEBPACK FOOTER //
// ./resources/js/store/store.js